import { TopNavigation } from '@velocity/ui/draft'
import * as React from 'react'
import { useCallback } from 'react'

import { useLocalization } from '@ngb-frontend/shared/context'

import type { AppLocale } from '@ngb-frontend/shared/types'
import type { LocaleSelectorChangeEvent } from '@velocity/ui/draft'

/** Brand logo and locale selector (the session country's locales only) */
export const BrandNavigationBar: React.FC = () => {
  const { locale, availableLocales, updateLocale } = useLocalization()

  const handleLocaleChange = useCallback(
    (e: LocaleSelectorChangeEvent) => {
      updateLocale(e.value as AppLocale)
    },
    [updateLocale],
  )

  return (
    <TopNavigation layoutContainerSize="fluid">
      <TopNavigation.Logo />
      <TopNavigation.LocaleSelector
        value={locale}
        localeCodeData={availableLocales}
        onChange={handleLocaleChange}
        data-e2e-component="locale-selector"
      />
    </TopNavigation>
  )
}
